import { render, staticRenderFns } from "./EditorForm.vue?vue&type=template&id=5665e78b&scoped=true"
import script from "./EditorForm.vue?vue&type=script&lang=js"
export * from "./EditorForm.vue?vue&type=script&lang=js"
import style0 from "./EditorForm.vue?vue&type=style&index=0&id=5665e78b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5665e78b",
  null
  
)

export default component.exports